import { Box, Heading, Image, Text } from '@chakra-ui/react';
import * as React from 'react';

import { useUnderMaintenanceConfig } from '../hooks/useFirebaseRemoteConfig';

export const MaintenanceScreen: React.FC = () => {
  const { underMaintenance } = useUnderMaintenanceConfig();

  const title = underMaintenance?.title || 'Under maintenance.';
  const description =
    underMaintenance?.description ||
    "Our systems are temporarily unavailable due to scheduled maintenance. We'll be back shortly.";
  const imageUrl =
    underMaintenance?.image_url ||
    'https://fleetpanda-public-files.s3.us-east-1.amazonaws.com/fleetpanda-maintenance.png';

  return (
    <Box
      minH="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="gray.900"
      py={{ base: '8', md: '16' }}
      px="6"
    >
      <Box maxW="600px" w="full">
        <Box
          display="flex"
          alignItems={{ base: 'center', md: 'center' }}
          flexDirection={{ base: 'column', md: 'row' }}
          gap={{ base: '4', md: '8' }}
          textAlign={{ base: 'center', md: 'left' }}
        >
          {imageUrl && (
            <Box flexShrink={0}>
              <Image
                src={imageUrl}
                alt="Maintenance"
                maxW={{ base: '120px', md: '150px' }}
                objectFit="contain"
                fallbackSrc="https://via.placeholder.com/350x250?text=Maintenance"
              />
            </Box>
          )}

          <Box flex="1">
            <Heading
              as="h1"
              fontSize={{ base: '2xl', md: '4xl' }}
              fontWeight="bold"
              color="white"
              lineHeight="shorter"
              mb="4"
            >
              {title}
            </Heading>

            <Text
              fontSize={{ base: 'md', md: 'lg' }}
              color="gray.200"
              whiteSpace="pre-wrap"
              lineHeight="tall"
            >
              {description}
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export type MaintenanceScreen = typeof MaintenanceScreen;
